module.exports = __webpack_public_path__ + "img/volunteer-hover.c6ce3c9d.png";